import React from 'react'

import Flag from '../../subcomponents/Flag'
import ContentBox from '../../subcomponents/ContentBox'

import { FootnotesFromContext } from "../../subcomponents/Footnotes";

import {default as t} from '../../utils/Translate'
import { useSuperscript } from '../../utils/SuperscriptHelper';

const TeaserAdditionalOffer = ({campaign, image, flagFilter, lang, footnotesWarningText}) => {
    const campaignWithSuperscript = {
        ...campaign,
        flagstoerer: useSuperscript(campaign.flagstoerer, true),
        copy_short: useSuperscript(campaign.copy_short, true),
        main_benefit_components_web: useSuperscript(campaign.main_benefit_components, true),
    }

    return(
        <div>
            <div className={'mam3-type border teaser-additional-offer no-logo'}>
                <div className="hero-wrapper">
                    {['Alle', 'CC Medien'].some(val => flagFilter.includes(val)) &&
                    <Flag text={campaignWithSuperscript.flagstoerer} appearance={campaign.flageye_catcher} />
                    }

                    <img src={campaign.image_16_9} className="hero img-fluid" role="presentation" alt="Hero" />
                </div>

                <ContentBox campaign={campaignWithSuperscript}>
                    {`${t(campaignWithSuperscript.copy_short, lang)}\n`}
                    {`__${t(campaignWithSuperscript.main_benefit_components_web, lang)}__`}
                </ContentBox>
            </div>
            <FootnotesFromContext showWarningText={footnotesWarningText} />
        </div>
    )

}

export default TeaserAdditionalOffer



// WEBPACK FOOTER //
// ./src/components/ads/creditcard/TeaserAdditionalOffer.js